import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { toExternalNature } from '@upright/common/model/input/types';
import { ApiPaiValues } from '@upright/common/model/output/eu-regulation/resolved-pais/types';
import { NumberHash } from '@upright/common/utils/number-hash/types';
import { getPaisForImpactCategory } from './pai-mapping';

export function getPaiNaturesForImpactCategory(impact: ImpactCategoryId, pais: ApiPaiValues) {
  const paisForCategory = getPaisForImpactCategory(impact);
  const countByNature: NumberHash = {};
  paisForCategory.forEach(paiId => {
    const pai = pais[paiId];
    if (pai) {
      const nature = toExternalNature(pai.nature);
      if (!countByNature[nature]) {
        countByNature[nature] = 0;
      }
      countByNature[nature]++;
    }
  });
  return countByNature;
}
